import { __decorate, __metadata } from "tslib";
import { DefaultExposeGroupEnum } from '@goparrot/common';
import { Expose, Type } from 'class-transformer';
import { ReadGiftCardReplicaDto } from './ReadGiftCardReplicaDto';
export class ReadGiftCardMappingDto {
}
__decorate([
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    __metadata("design:type", String)
], ReadGiftCardMappingDto.prototype, "gan", void 0);
__decorate([
    Type(() => ReadGiftCardReplicaDto),
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    __metadata("design:type", Array)
], ReadGiftCardMappingDto.prototype, "replicas", void 0);
__decorate([
    Type(() => Date),
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    __metadata("design:type", Date)
], ReadGiftCardMappingDto.prototype, "createdAt", void 0);
__decorate([
    Type(() => Date),
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    __metadata("design:type", Date)
], ReadGiftCardMappingDto.prototype, "updatedAt", void 0);
//# sourceMappingURL=ReadGiftCardMappingDto.js.map